const getObjectValues = (obj) =>
  obj && typeof obj === "object" ?
    Object.values(obj)
      .map(getObjectValues)
      .reduce((a, b) => a.concat(b), [])
  : [obj];

export default getObjectValues;
